import { render, staticRenderFns } from "./amazonLicensing.vue?vue&type=template&id=7df70180&scoped=true&"
import script from "./amazonLicensing.vue?vue&type=script&lang=js&"
export * from "./amazonLicensing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df70180",
  null
  
)

export default component.exports